<template>
    <div>
        <h1 class="subtitle">Asignación y Devolución de Items</h1>
        <b-tabs v-model="activeTab"
                :animated="false"
                @input="changeTab($event)"
                type="is-boxed"
                size="is-small"
                position="is-left">
            <b-tab-item label="Asignaciones / Devoluciones">
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-grid">
                            <InputSelect label="Asignaciones / Devoluciones"
                                         v-model="tipo_asignacion"
                                         :source="tipos_asignaciones"
                                         itemKey="tia_id"
                                         itemValue="tia_id"
                                         itemFilter="tia_nombre"
                                         :labelFunction="(item) => item.tia_nombre"
                                         @selectItem="seleccionarTipoBusqueda">
                            </InputSelect>
                            <InputSelect label="Almacenes"
                                         v-model="request.alm_id"
                                         :source="almacenes"
                                         itemKey="alm_id"
                                         itemValue="alm_id"
                                         :filterFunction="filterAlmacenes"
                                         :labelFunction="labelAlmacen">
                            </InputSelect>
                            <InputSelect label="Solicitante"
                                         v-model="request.emp_solicitante"
                                         :source="solicitantes"
                                         itemKey="epr_id"
                                         itemValue="emp_id"
                                         :filterFunction="filterUsuario"
                                         :labelFunction="labelEmpleado">
                            </InputSelect>
                            <InputSelect label="Autorizador"
                                         v-model="request.emp_autorizador"
                                         :source="autorizadores"
                                         itemKey="epr_id"
                                         itemValue="emp_id"
                                         :filterFunction="filterUsuario"
                                         :labelFunction="labelEmpleado">
                            </InputSelect>
                            <div>
                                <div class="nj-label">N° Asignacion</div>
                                <input type="text"
                                       class="nj-text"
                                       v-model="request.asi_id"
                                       ref="asi_id">
                            </div>
                            <InputDate label="Rango fechas"
                                       v-model="request.asi_fecha_inicio"></InputDate>
                            <InputDate label=""
                                       v-model="request.asi_fecha_fin"></InputDate>
                            <InputSelect label="Estados"
                                         v-model="estado"
                                         :source="estados"
                                         itemKey="est_id"
                                         itemValue="est_id"
                                         itemFilter="est_nombre"
                                         :labelFunction="labelEstado">
                            </InputSelect>
                        </div>
                        <br>
                        <div class="nj-flex">
                            <Button label="Buscar"
                                    icon="search"
                                    @click="buscar()"></Button>
                            <Button label="Asignar"
                                    icon="save"
                                    color="green"
                                    @click="popup({ view: 'RegistrarAsignacionItems' })"
                                    activationCode="registrar_asignacion"></Button>
                            <Button label="Devolver"
                                    icon="save"
                                    color="blue"
                                    @click="popup({ view: 'RegistrarDevolucionItems' })"
                                    activationCode="registrar_devolucion"></Button>
                        </div>
                        <br>
                        <b-table v-if="tipo_asignacion == 1"
                                 :data="asignaciones"
                                 :paginated="true"
                                 :per-page="10"
                                 current-page.sync="1"
                                 :pagination-simple="true"
                                 pagination-position="bottom"
                                 default-sort-direction="asc"
                                 :pagination-rounded="false"
                                 sort-icon="arrow-up"
                                 sort-icon-size="is-small"
                                 aria-next-label="Next page"
                                 aria-previous-label="Previous page"
                                 aria-page-label="Page"
                                 aria-current-label="Current page">
                            <template slot-scope="props">
                                <b-table-column label="ID"
                                                header-class="is-info">
                                    {{ props.row.asi_id }}
                                </b-table-column>
                                <b-table-column label="Fecha asignación"
                                                header-class="is-info">
                                    {{ props.row.asi_fecha_registro }}
                                </b-table-column>
                                <b-table-column label="Solicitante"
                                                header-class="is-info">
                                    {{ props.row.emp_solicitante_nombre }}
                                </b-table-column>
                                <b-table-column label="Autorizador"
                                                header-class="is-info">
                                    {{ props.row.emp_autorizador_nombre }}
                                </b-table-column>
                                <b-table-column label="Registrado por"
                                                header-class="is-info">
                                    {{ props.row.usu_registrador_nombre }}
                                </b-table-column>
                                <b-table-column label="Estado"
                                                header-class="is-info">
                                    <b-field>
                                        <b-tag :class="props.row.est_styles">{{ props.row.est_nombre }}</b-tag>
                                    </b-field>
                                </b-table-column>
                                <b-table-column label="Opciones"
                                                header-class="is-info">
                                    <div class="nj-flex">
                                        <Button title="Ver asignacion"
                                                icon="info"
                                                @click="popup({ view: 'VerAsignacionItems', asi_id: props.row.asi_id })"></Button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                        <b-table v-if="tipo_asignacion == 2"
                                 :data="devoluciones"
                                 :paginated="true"
                                 :per-page="10"
                                 current-page.sync="1"
                                 :pagination-simple="true"
                                 pagination-position="bottom"
                                 default-sort-direction="asc"
                                 :pagination-rounded="false"
                                 sort-icon="arrow-up"
                                 sort-icon-size="is-small"
                                 aria-next-label="Next page"
                                 aria-previous-label="Previous page"
                                 aria-page-label="Page"
                                 aria-current-label="Current page">
                            <template slot-scope="props">
                                <b-table-column label="ID"
                                                header-class="is-info">{{ props.row.asi_id
                                                }}</b-table-column>
                                <b-table-column label="Fecha asignación"
                                                header-class="is-info">{{
                                                    props.row.did_fecha_registro }}</b-table-column>
                                <b-table-column label="Solicitante"
                                                header-class="is-info">{{
                                                    props.row.emp_solicitante_nombre
                                                }}</b-table-column>
                                <b-table-column label="Autorizador"
                                                header-class="is-info">{{
                                                    props.row.emp_autorizador_nombre
                                                }}</b-table-column>
                                <b-table-column label="Registrado por"
                                                header-class="is-info">{{
                                                    props.row.usu_registrador_nombre
                                                }}</b-table-column>
                                <b-table-column label="Estado"
                                                header-class="is-info">
                                    <b-field>
                                        <b-tag :class="props.row.est_styles">{{ props.row.est_nombre }}</b-tag>
                                    </b-field>
                                </b-table-column>
                                <b-table-column label="Opciones"
                                                header-class="is-info">
                                    <div class="nj-flex">
                                        <Button title="Ver devolución"
                                                icon="info"
                                                @click="popup({ view: 'VerDevolucionItems', dei_id: props.row.dei_id })"></Button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </b-tab-item>
            <b-tab-item label="Asignaciones x Items">
                <div class="nj-panel">
                    <div class="nj-panel-content">
                        <div class="nj-grid">
                            <InputSelect label="Almacen"
                                         v-model="request2.alm_id"
                                         :source="almacenes"
                                         itemKey="alm_id"
                                         itemValue="alm_id"
                                         :filterFunction="filterAlmacenes"
                                         :labelFunction="labelAlmacen">
                                <template #default="data">
                                    {{ labelAlmacen(data.item) }}
                                </template>
                            </InputSelect>
                            <SearchBox label="Item"
                                       v-model="request2.prv_id"
                                       itemKey="prv_id"
                                       itemValue="prv_id"
                                       :source="productos"
                                       :searchFunction="buscarProducto">
                                <template #default="data">
                                    {{ data.item.prv_nombre }}
                                </template>
                            </SearchBox>
                            <InputSelect label="Solicitante"
                                         v-model="request2.emp_solicitante"
                                         :source="solicitantes"
                                         itemKey="emp_id"
                                         itemValue="emp_id"
                                         :filterFunction="filterUsuario"
                                         :labelFunction="labelEmpleado">
                                <template #default="data">
                                    {{ labelEmpleado(data.item) }}
                                </template>
                            </InputSelect>
                            <InputSelect label="Autorizador"
                                         v-model="request2.emp_autorizador"
                                         :source="autorizadores"
                                         itemKey="emp_id"
                                         itemValue="emp_id"
                                         :filterFunction="filterUsuario"
                                         :labelFunction="labelEmpleado">
                                <template #default="data">
                                    {{ labelEmpleado(data.item) }}
                                </template>
                            </InputSelect>
                            <div class="nj-flex">
                                <InputDate label="Rango fechas"
                                           v-model="asi_fecha_inicio"></InputDate>
                                <InputDate label=""
                                           v-model="asi_fecha_fin"></InputDate>
                            </div>
                        </div>
                        <br>
                        <div class="nj-flex">
                            <Button label="Buscar"
                                    icon="search"
                                    @click="buscarAsignacionesxItems()"></Button>
                        </div>
                        <br>
                        <b-table :data="asignaciones_x_items"
                                 @page-change="changePage($event)"
                                 :total="request2.page.total"
                                 :per-page="request2.page.size"
                                 :current-page="request2.page.number"
                                 :paginated="true"
                                 :backend-pagination="true"
                                 pagination-order="is-centered">
                            <template slot-scope="props">
                                <b-table-column label="Producto"
                                                header-class="is-info">{{ props.row.prv_nombre
                                                }}</b-table-column>
                                <b-table-column label="Cantidad"
                                                header-class="is-info">{{ props.row.aid_cantidad
                                                }}</b-table-column>
                                <b-table-column label="Saldo"
                                                header-class="is-info">{{ props.row.aid_saldo
                                                }}</b-table-column>
                                <b-table-column label="Solicitante"
                                                header-class="is-info">{{
                                                    props.row.emp_solicitante_nombre
                                                }}</b-table-column>
                                <b-table-column label="Autorizador"
                                                header-class="is-info">{{
                                                    props.row.emp_autorizador_nombre
                                                }}</b-table-column>
                                <b-table-column label="Fecha registro"
                                                header-class="is-info">{{
                                                    props.row.asi_fecha_registro
                                                }}</b-table-column>
                                <b-table-column label="Opciones"
                                                header-class="is-info"
                                                style="width: 80px;">
                                    <Button title="Devoluciones"
                                            icon="info"
                                            @click="popup({ view: 'DevolucionesxItem', asi_id: props.row.asi_id, prv_nombre: props.row.prv_nombre })"></Button>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </b-tab-item>
        </b-tabs>
        <RegistrarAsignacionItems v-if="view == 'RegistrarAsignacionItems'"
                                  @close="popup($event)">
        </RegistrarAsignacionItems>
        <VerAsignacionItems v-if="view == 'VerAsignacionItems'"
                            @close="popup($event)"
                            :asi_id="asi_id">
        </VerAsignacionItems>
        <RegistrarDevolucionItems v-if="view == 'RegistrarDevolucionItems'"
                                  @close="popup($event)">
        </RegistrarDevolucionItems>
        <VerDevolucionItems v-if="view == 'VerDevolucionItems'"
                            @close="popup($event)"
                            :dei_id="dei_id">
        </VerDevolucionItems>
        <DevolucionesxItem v-if="view == 'DevolucionesxItem'"
                           @close="popup($event)"
                           :aid_id="aid_id"
                           :prv_nombre="prv_nombre">
        </DevolucionesxItem>
    </div>
</template>

<script>
import { EstadoEnum } from "../../constants"
import { AsignacionItemsService, DevolucionItemsService, EmpleadoService, LabelService, ProductoAlmacenService, ResponseStatus, UsuarioService } from "../../services"
import AlmacenService from '../../services/AlmacenService'
import OpcionesService from "../../services/OpcionesService"
import { Confirm, DateTime, Validator } from "../../util"
import Toast from "../../util/toast"
import { Button, Buttons, InputDate, InputSelect, InputSimpleSelect, InputText, SearchBox } from "../components"
import DevolucionesxItem from "./DevolucionesxItem.vue"
import RegistrarAsignacionItems from "./RegistrarAsignacionItems"
import RegistrarDevolucionItems from "./RegistrarDevolucionItems"
import VerAsignacionItems from "./VerAsignacionItems"
import VerDevolucionItems from "./VerDevolucionItems"

export default {
    name: "AsignacionItems",
    data() {
        return {
            tipos_asignaciones: [],
            tipo_asignacion: 1,
            estado: 3,
            estados: [],
            // * para buscar asignaciones o devoluciones
            request: {
                asi_id: null,
                alm_id: null,
                emp_solicitante: null,
                asi_fecha_inicio: null,
                asi_fecha_fin: null,
                asi_estado: null,
                did_estado: null,
            },
            // * para buscar asignaciones x item
            request2: {
                alm_id: null,
                emp_solicitante: null,
                emp_autorizador: null,
                asi_fecha_inicio: null,
                asi_fecha_fin: null,
                asi_estado: null,
                prv_id: null,
                page: {
                    number: 1,
                    size: 10
                }
            },
            emp_nombre: "",

            view: "",
            activarAsignar: false,
            activarDevolver: false,
            activarAsignacionView: false,
            activarDevolucionView: false,
            activarDevolucionesxItem: false,

            asignaciones: [],
            devoluciones: [],
            almacenes: [],
            productos: [],
            solicitantes: [],
            autorizadores: [],
            asignaciones_x_items: [],

            asi_id: null,
            aid_id: null,
            dei_id: null,
            activeTab: 0,
            asi_fecha_inicio: null,
            asi_fecha_fin: null,
            prv_nombre: null,
        }
    },
    components: {
        RegistrarAsignacionItems,
        VerAsignacionItems,
        RegistrarDevolucionItems,
        VerDevolucionItems,
        Buttons,
        Button,
        InputText,
        InputSelect,
        InputSimpleSelect,
        SearchBox,
        InputDate,
        DevolucionesxItem,
    },
    methods: {
        changeTab(tab) {
            switch (tab) {
                case 0:
                    this.buscar()
                    break
                case 1:
                    this.buscarAsignacionesxItems()
                    break
                case 2:
                    break
            }
        },
        seleccionarTipoBusqueda() {
            this.buscar()
        },
        buscar() {
            this.asignaciones = []
            this.devoluciones = []
            if (this.tipo_asignacion == 1) {
                this.request.asi_estado = this.estado
                AsignacionItemsService
                    .buscar({
                        asignacion_items: this.request
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.asignaciones = response.data
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            } else {
                this.request.dei_estado = this.estado
                DevolucionItemsService
                    .buscar({
                        devolucion_items: this.request
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.devoluciones = response.data
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
        },
        buscarEmpleado() {
            AsignacionItemsService
                .buscarEmpleado({
                    pry_id: UsuarioService.getProject()
                })
                .then(response => {
                    this.autorizadores = response.data
                    this.solicitantes = response.data
                })
                .catch(error => {
                    Toast.error(error)
                })
                .finally(() => {
                    this.buscar()
                })

        },
        filterUsuario(items, param) {
            if (param != null && param != "") {
                return items.filter(item => item.emp_nombre_completo.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelEmpleado(item) {
            return UsuarioService.isCoorporative()
                ? LabelService.empleadoProyecto(item)
                : LabelService.empleado(item)
        },
        eliminarAsignacion(item) {
            Confirm.show({
                message: "¿Esta seguro de eliminar la asignación?",
                action: () => {
                    AsignacionItemsService
                        .eliminar({
                            asignacion_items: {
                                asi_id: item.asi_id
                            }
                        })
                        .then(response => {
                            if (ResponseStatus.isSuccess(response)) {
                                Toast.success(response.message)
                                this.buscar()
                            }
                            else {
                                Toast.error(response.message)
                            }
                        })
                        .catch(error => {
                            Toast.error(error)
                        })
                }
            })
        },
        eliminarDevolucion(item) {
            Confirm.show({
                message: "¿Esta seguro de eliminar la devolución?",
                action: () => {
                    const request = {
                        devolucion_items: {
                            dei_id: item.dei_id
                        }
                    }
                    DevolucionItemsService.eliminar(request).then(
                        response => {
                            Toast.success(response.message)
                            this.buscar()
                        },
                        error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        }
                    )
                }
            })
        },
        labelAlmacen(item) {
            return `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`
        },
        filterAlmacenes(items, param) {
            if (param != null) {
                return items.filter(item => `${item.pry_nombre} | ${item.alm_nombre} ${item.alm_tipo == 0 ? "*" : ""}`.toLowerCase().includes(param.toLowerCase()))
            }
            else {
                return items
            }
        },
        labelEstado(item) {
            return item.est_nombre
        },
        buscarAsignacionesxItems() {
            if (this.asi_fecha_inicio) {
                this.request2.asi_fecha_inicio = DateTime.dateToString(this.asi_fecha_inicio)
            }
            if (this.asi_fecha_fin) {
                this.request2.asi_fecha_fin = DateTime.dateToString(this.asi_fecha_fin)
            }
            const request = {
                asignacion_items_detalle: this.request2
            }
            AsignacionItemsService.buscarAsignacionesxItems(request).then(response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.request2.page = response.data
                    this.asignaciones_x_items = this.request2.page.list
                }
                else {
                    Toast.error(response.message)
                }
            }).catch(error => {
                Toast.error(error)

            })
        },
        changePage(number) {
            this.request2.page.number = number
            this.buscarAsignacionesxItems()
        },
        buscarProducto(prv_nombre) {
            if (Validator.start(this.request2.alm_id)) {
                ProductoAlmacenService
                    .buscarRapido({
                        producto_almacen: {
                            prv_nombre,
                            alm_id: this.request2.alm_id
                        }
                    })
                    .then(response => {
                        if (ResponseStatus.isSuccess(response)) {
                            this.productos = response.data
                        }
                        else {
                            Toast.error(response.message)
                        }
                    })
                    .catch(error => {
                        Toast.error(error)
                    })
            }
            else {
                Toast.error("Debe seleccionar un almacén")
            }
        },
        popup({
            view,
            asi_id = null,
            dei_id = null,
            prv_nombre = null,
            buscar = false
        }) {
            this.view = view
            this.asi_id = asi_id
            this.dei_id = dei_id
            this.prv_nombre = prv_nombre
            if(buscar) {
                this.buscar()
            }
        },
        obtenerTipos() {
            AsignacionItemsService
                .obtenerTipos()
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.tipos_asignaciones = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
                .finally(() => {
                    // obteniendo los estados
                    this.obtenerEstados()
                })
        },
        obtenerEstados() {
            AsignacionItemsService
                .obtenerEstados()
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.estados = response.data
                        // this.estado = 3
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
                .finally(() => {
                    // obteniendo los almacenes
                    this.obtenerAlmacenes()
                })
        },
        obtenerAlmacenes() {
            AlmacenService
                .obtenerxProyecto(UsuarioService.getProject())
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.almacenes = response.data
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                })
                .finally(() => {
                    this.buscarEmpleado()
                })
        },
    },
    beforeMount() {
        UsuarioService.obtenerOpciones()
    },
    mounted() {
        this.obtenerTipos()
    },
}
</script>

<style scoped></style>